import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./ForthBox.module.css";
import Faq from "./Faq";

const ForthBox = () => {
  return (
    <div className="forth">
      <div className={styles.forthBox}>
        <h1 className={styles.title}>سوالات متداول </h1>
        <div className={styles.faq}>
          <Faq title="هزینه طراحی وبسایت چه قدر است؟" icon="fa-duotone fa-tag">
            هزینه طراحی وبسایت و وب اپ، بستگی به سفارش مشتری دارد. شروع قیمت
            طراحی وبسایت در ایرلوکس از ۱۰ میلیون تومان می باشد که صرفا یک سایت تک
            صفحه ای استاتیک می باشد.
          </Faq>

          <Faq
            title="نحوه ی قیمت گذاری ایرلوکس چگونه است؟"
            icon="fa-regular fa-money-check-pen"
          >
            طراحی سایت تا انتشار آن برروی اینترنت طی ۳ مرحله انجام می شود. مرحله
            اول،طراحی گرافیکی سایت یا UI/UX، مرحله دوم برنامه نویسی وبسایت و
            مرحله سوم هاستینگ و دامنه وبسایت می باشد. هرکدام از این مراحل در
            قیمت گذاری نهایی دخیل هستند.
          </Faq>
          <Faq
            title="تفاوت وب اپ با وبسایت چیست؟"
            icon="fa-solid fa-code-compare"
          >
            وقتی از وبسایت صحبت می کنیم، منظور یک صفحه ی اینترنتی است که صرفا یک
            اطلاعات ثابت را در اختیار بازدید کننده به نمایش می گذارد، اما وب اپ
            یعنی یک برنامه ای که بر بستر اینترنت درحال اجرا می باشد و این برنامه
            میتواند یک فروشگاه اینترنتی و یا یک تاکسی اینترنتی مانند اسنپ! باشد.
          </Faq>
          <Faq
            title="تیم ایرلوکس، طراحی وبسایت انجام می دهد یا وب اپ؟"
            icon="fa-solid fa-browser"
          >
      تیم ایرلوکس، هردو مورد طراحی و پیاده سازی وب اپ و طراحی وبسایت را انجام می دهد.
         </Faq>
          <Faq
            title="اطلاعات مورد نیاز برای ایجاد یک وبسایت چیست؟"
            icon="fa-solid fa-info"
          >
            با تیم ما تماس بگیرید و در این مورد ما شما راهنمایی خواهیم کرد!
          </Faq>
          <Faq
            title="مدت زمان آماده سازی وبسایت من چه قدر است؟"
            icon="fa-regular fa-timer"
          >
            آماده سازی یک وبسایت با توجه به این که ابتدا توسط متخصص UI/UX طراحی
            می شود و سپس وارد پروسه برنامه نویسی میگردد و همچنین لحاظ نمودن
            امکانات مورد نیاز مشتری از یک ماه می باشد.
          </Faq>
        </div>
        <div className={styles.irluxeinstagram}>
          <a href="https://instagram.com/irluxe_co">
            IRLUXE <i className="fa-brands fa-instagram"></i> 
          </a>
        </div>
        
      </div>
    </div>
  );
};

export default ForthBox;
